<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdtpmovimento }}</div>
                </div>
                
                <div class="form-item flexible">
                    <label class="label-caption">Nome/Descrição</label>
                    <input type="text" v-model="objEdicao.nmtpmovimento" required maxlength="100" v-uppercase />
                </div>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Detalhamento</label>
                    <textarea v-model="objEdicao.obs" maxlength="1000" rows="5" style="resize: none;"/>
                </div>
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input id="ckAtivo" type="checkbox" class="input-checkbox" v-model="ckAtivo" />
            </div>

            <div class="row-end">
                <label for="ckOsVinculada">Vinculado com OS</label>
                <input id="ckOsVinculada" type="checkbox" class="input-checkbox" v-model="ckOsVinculada" />
            </div>


            <div class="row-end margin-top10">
                <button type="submit" class="btn-confirm">Salvar</button>
                <button type="cancel" class="btn-cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>
    </div>
</template>
  
<script>
import { ref } from 'vue';
import { criarBancoHrTpMovimento } from '@/models/BancoHrTpMovimento';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';

export default {
    emits: ['close', 'salvo'],
    props: {idEdicao: {type: Number, default: 0}},
    setup(props, { emit }) {
        const ckAtivo = ref(false);
        const ckOsVinculada = ref(false);
        const objEdicao = criarBancoHrTpMovimento();
        const isLoading = ref(false);

        const submitForm = async () => {
            try {
                isLoading.value              = true;
                objEdicao.ativo              = ckAtivo.value ? 'S' : 'N';
                objEdicao.osvinculada        = ckOsVinculada.value ? 'S' : 'N';
                const response               = await genericPut('/cad/bancohr_tpmovimento', objEdicao);
                if (response.bolok === 1){
                    emit('salvo');
                    emit('close');
                }else{
                    alert(response.erro);
                }
            } catch (error) {console.error('Error:', error);
            } finally{isLoading.value=false;}
        };

        const cancelForm = () => {emit('close');};

        const lerDados = async() => {
            try{
                isLoading.value=true;
                if (props.idEdicao > 0) {
                    try{
                        const req = await getCadastroById('bancohr_tpmovimento', props.idEdicao);
                        Object.assign(objEdicao, req[0]);
                        console.log(req);
                    }catch (error){console.error('Erro leitura dos dados', error);}
                }else{
                    objEdicao.idmunicipio = globalStore.idmunicipio;
                }
                objEdicao.idusuario     = globalStore.idusuario;
                ckAtivo.value           = objEdicao.ativo === 'S';
                ckOsVinculada.value     = objEdicao.osvinculada === 'S';
            }finally{isLoading.value=false;}
        };

        lerDados();

        return {ckAtivo, ckOsVinculada, isLoading, objEdicao, submitForm, cancelForm };
    }
};
</script>